import LabelFormat from '~/types/LabelFormat';

export const LABEL_FORMATS_SIZES: Record<LabelFormat, string | undefined> = {
  [LabelFormat.PDF]: '8.5x11',
  [LabelFormat.PDF_2_3x7_5]: '2.3x7.5',
  [LabelFormat.PDF_4x6]: '4x6',
  [LabelFormat.PDF_4x8]: '4x8',
  [LabelFormat.PDF_A4]: '8.26x11.69',
  [LabelFormat.PDF_A6]: '4.13x5.83',
  [LabelFormat.PDF_SINGLE_8X11]: '8.5x11',
  [LabelFormat.PDF_W_PSLIP_8x11]: '8.5x11',
  [LabelFormat.PDF_W_PSLIP_COLLATED_4x6]: '4x6',
  [LabelFormat.PDF_W_PSLIP_COLLATED_4x8]: '4x8',
  [LabelFormat.PDF_W_PSLIP_COLLATED_8x11]: '8.5x11',
  [LabelFormat.PNG]: undefined,
  [LabelFormat.PNG_2_3x7_5]: '2.3x7.5',
  [LabelFormat.ZPLII]: undefined,
};
